import React from 'react'

const BoatingReservations = () => {
  return (
    <div>
      Reservations
    </div>
  )
}

export default BoatingReservations
